import { AttachmentWellViewState } from 'owa-attachment-well-data';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';

export default function fixInlineImageSrc(viewState: AttachmentWellViewState, cidOrName: string) {
    if (viewState.inlineAttachments) {
        for (const attachmentData of viewState.inlineAttachments) {
            const attachment = getAttachment(attachmentData.attachmentId);
            if (
                attachment?.thumbnailImage &&
                attachment.model &&
                (attachment.model.ContentId == cidOrName || attachment.model.Name == cidOrName)
            ) {
                return {
                    url: attachment.thumbnailImage.url,
                    contentId: attachment.model.ContentId,
                };
            }
        }
    }

    return null;
}
